import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Award, ShieldCheck, XCircle } from "lucide-react";

export default function VerifyCertificate() {
  const { code } = useParams();
  const [d, setD] = useState(undefined);
  useEffect(() => { api.get(`/certificates/verify/${code}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [code]);
  if (d === undefined) return <div className="max-w-xl mx-auto px-4 py-20 text-lg">Checking certificate…</div>;
  return (
    <div className="max-w-xl mx-auto px-4 py-16">
      <div data-testid="verify-certificate" className={`rounded-3xl p-8 text-center border-4 ${d ? "bg-white border-[#2E7D6B]" : "bg-[#FFF5F5] border-red-300"}`}>
        {d ? (
          <>
            <ShieldCheck className="w-14 h-14 text-[#2E7D6B] mx-auto" />
            <h1 className="text-2xl font-display font-bold text-slate-900 mt-3">Genuine Kindred certificate</h1>
            <p data-testid="verify-helper" className="text-xl text-slate-800 mt-4"><b>{d.helper_name}</b> volunteered <b>{d.hours} hours</b> across {d.jobs} visits</p>
            <p className="text-slate-600 mt-1">{d.period_label} · issued {new Date(d.issued_at).toLocaleDateString()}</p>
            <p className="text-sm text-slate-500 mt-4 flex items-center justify-center gap-1"><Award className="w-4 h-4" /> Certificate ID {d.code}</p>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h1 className="text-2xl font-display font-bold text-slate-900 mt-3">We couldn't find this certificate</h1>
            <p className="text-slate-600 mt-2">Check the ID printed at the bottom of the certificate ({code}).</p>
          </>
        )}
      </div>
    </div>
  );
}
